export const PRODUCT_LINES = [
  {
    id: 'chromalux',
    name: 'Chromalux',
    accent: 'gold',
    tagline: 'Color, white & black masterbatch for every polymer.',
    description:
      'High-performance color concentrates engineered for vivid, consistent color across injection molding, blown film, extrusion, and fiber applications. ΔE < 0.5 batch-to-batch.',
    icon: 'palette',
    solutions: [
      'Color Masterbatch: Pantone & RAL Shades, EN-71 Compliance, Colour+Additive Combi batches',
      'White Masterbatch: Up to 70% TiO2, Anti Yellow Formulations',
      'Black Masterbatch: Up to 50% CB, High Tint & Superior Gloss, FDA',
      'Special Effect: Pearl, Metallics, Marble, Granite, Glitters',
    ],
  },
  {
    id: 'fortilux',
    name: 'Fortilux',
    accent: 'blue',
    tagline: 'Functional & performance additive concentrates.',
    description:
      'UV stabilizers, NIR absorbers, antistatic agents, and multifunctional additive packages — single-pellet performance without compromising processability.',
    icon: 'shield',
    solutions: [
      'UV Absorbers & Stabilizer',
      'NIR Absorber',
      'Antistatic & Anti Oxidant',
      'Anti Microbials',
      'Slip & Antiblocks',
      'PFAS Free Processing Aids',
      'Halogen Free Flame Retardants',
      'Light Diffusers',
    ],
  },
  {
    id: 'verdalux',
    name: 'Verdalux',
    accent: 'green',
    tagline: 'Sustainable, recyclable-ready & bio-based solutions.',
    description:
      'rPET-compatible, NIR-sortable, and bio-attributed carrier systems validated through simulated mechanical recycling loops before commercial launch.',
    icon: 'leaf',
    solutions: [
      'Bio & rPET Solutions',
      'NIR-Sortable Black',
      'Recyclable-Ready MB',
      'Bio-Based Carriers',
      'Compatibilizers',
      'MFI Regulators',
      'Odor Scavengers',
      'Desiccants',
    ],
  },
  {
    id: 'formalux',
    name: 'Formalux',
    accent: 'navy',
    tagline: 'Custom-engineered compounds and tailored systems.',
    description:
      'Application-specific compounds and tailored masterbatch systems co-developed with your technical team — from first trial to full scale-up.',
    icon: 'flask',
    solutions: [
      'Custom Compounds',
      'Pre Colored Resins',
      'Mono Concentrates',
      'Medical-Grade Compounds',
    ],
  },
];
